import { useApi } from '@/api'

export const useMcpResource = () => {
  const api = useApi()
  const connectionsOf = (organizationId: string) => api.api.v1.organizations({ organizationId })['mcp-connections']

  return {
    getMcpConnections: (organizationId: string) => connectionsOf(organizationId).get(),
    delMcpConnection: (organizationId: string, connectionId: string) => connectionsOf(organizationId)({ connectionId }).delete(undefined)
  }
}
